import { useEffect } from "react";

import { isMiniApp } from "../auth";
import { useWebChrome } from "../webChrome";

/** Кнопка «Назад»: нативная в Mini App, фолбэком в вебе. */
export function useBackButton(visible: boolean, onClick: () => void) {
  const setBack = useWebChrome()?.setBack;

  // Mini App: нативный Telegram BackButton.
  useEffect(() => {
    if (!isMiniApp()) return;
    const btn = window.Telegram?.WebApp?.BackButton;
    if (!btn) return;
    if (visible) btn.show();
    else btn.hide();
    btn.onClick(onClick);
    return () => {
      btn.offClick(onClick);
      btn.hide();
    };
  }, [visible, onClick]);

  // Веб: фолбэк через WebChrome.
  useEffect(() => {
    if (isMiniApp() || !setBack) return;
    setBack({ visible, onClick });
    return () => setBack(null);
  }, [setBack, visible, onClick]);
}
